import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { browserHistory } from 'react-router'

const ItemServiceCard = props => (
  <tr key={props.indexKey} onClick={() => { browserHistory.push(`/products/${props.product.id}`) }}>
    <td> { parseInt(props.skip, 0) + props.indexKey + 1} </td>
    <td> {moment(props.product.createdAt).format('MMMM Do YYYY')} </td>
    <td> {moment(props.product.updatedAt).format('MMMM Do YYYY')} </td>
    <td> <span>{props.product.name}</span> </td>
    { props.product.productType &&
      <td> <span>{props.product.productType.name}</span> </td> }
    <td> <span>{ props.product.isEligible ? 'Eligible' : 'Non Eligible' }</span> </td>
    <td> <span>{ props.product.isPublished ? 'Publish' : 'Unpublish' }</span> </td>
  </tr>
)

ItemServiceCard.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    name: PropTypes.string,
    productType: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    isEligible: PropTypes.bool.isRequired,
    isPublished: PropTypes.bool.isRequired,
  }).isRequired,
  indexKey: PropTypes.number.isRequired,
  skip: PropTypes.number.isRequired,
}

export default ItemServiceCard
